import type { UserRoleCanClaimTripsDetail } from "../models/UserRoleCanClaimTripsDetail";

export type RoleDetailsKeys = "can-claim-trips" | "regional-manager" | "senior-regional-manager";
export const roleDetailsKeys: RoleDetailsKeys[] = ["can-claim-trips", "regional-manager", "senior-regional-manager"];
export type RoleDetails = {
    "can-claim-trips"?: UserRoleCanClaimTripsDetail;
    "regional-manager"?: { countryIds: string[] };
    "senior-regional-manager"?: { countryIds: string[] };
};
